<template>
  <form name="users-form" @submit.prevent="$emit('save')">
    <v-row>
      <v-col>
        <UsersFormMain
          ref="main"
          :form="form"
          :is-create="isCreate"
          :is-view="isView"
          :is-edit="isEdit"
          :is-profile="isProfile"
          :skeleton="skeleton"
          class="my-4"
          @change-password="$listeners['change-password']"
        />

        <UsersFormDetails
          ref="details"
          :form="form"
          :is-create="isCreate"
          :is-view="isView"
          :is-edit="isEdit"
          :is-profile="isProfile"
          :skeleton="skeleton"
          @change-ate="updateUserTimezone"
        />

        <slot name="left" />
      </v-col>

      <template v-if="!isProfile || $slots.right">
        <v-col cols="12" md="auto">
          <div class="users-form__status-container">
            <UsersFormStatus
              v-if="!isProfile"
              :form="form"
              :is-create="isCreate"
              :is-view="isView"
              :is-edit="isEdit"
              :skeleton="skeleton"
              class="mb-4"
            />

            <slot name="right" />
          </div>
        </v-col>
      </template>
    </v-row>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import VueSuperMethod from 'vue-super-call'

import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import UsersFormMain from './UsersForm/UsersFormMain.vue'
import UsersFormDetails from './UsersForm/UsersFormDetails.vue'
import UsersFormStatus from './UsersForm/UsersFormStatus.vue'
import { CancelToken, isCancel } from 'axios'
import { AteMunicipalitiesApi, AteRegionsApi } from '@/api/resources'

const createDefaultData = () => ({
  // id
  username: void 0,
  // email
  full_name: void 0,
  password: void 0,
  // created_at
  // updated_at
  // deleted_at
  is_active: true,
  is_federal_level: false,
  // last_login_ip
  // last_login_at
  // last_password_change_at
  // photo
  address: void 0,
  phone: void 0,
  comment: void 0,

  region: null,
  region_id: null,

  municipality: null,
  municipality_id: null,

  school: null,
  school_id: null,

  timezone: null,
  timezone_id: null,
})

export default {
  name: 'UsersForm',
  components: {
    UsersFormMain,
    UsersFormDetails,
    UsersFormStatus,
  },
  extends: BLayoutForm,
  props: {
    isProfile: Boolean,
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  data: () => ({
    get regionsApi() {
      return new AteRegionsApi()
    },
    get municipalitiesApi() {
      return new AteMunicipalitiesApi()
    },
  }),
  methods: {
    async onSubmit() {
      const result = await this.$validator.validate()

      if (!result) {
        this.$notice.validatorFormError(this)
        const message = `Error submit: ${this.$options.name}`
        const error = new Error(message)
        return Promise.reject(error)
      }

      const { form } = this

      const data = {
        ...form,

        region: void 0,
        region_id: form.region?.id ?? null,

        municipality: void 0,
        municipality_id: form.municipality?.id ?? null,

        school: void 0,
        school_id: form.school?.id ?? null,

        timezone: void 0,
        timezone_id: form.timezone?.id ?? null,
      }

      this.$emit('submit', data)

      return data
    },
    onReset() {
      void this.$refs.main?.onReset()
      VueSuperMethod.call(this, BLayoutForm).onReset()
    },
    async updateUserTimezone() {
      void this.cancelTokenSource?.cancel(this.$options.name)
      this.cancelTokenSource = CancelToken.source()
      const cancelToken = this.cancelTokenSource.token
      const config = { cancelToken }
      const { form } = this
      let info

      if (form.school?.municipality_id || form.municipality?.id) {
        info = await this.getATEInfo(
          this.municipalitiesApi,
          form.school?.municipality_id || form.municipality?.id,
          config,
        )
      } else if (form.region?.id) {
        info = await this.getATEInfo(this.regionsApi, form.region?.id, config)
      }
      form.timezone = info?.timezone
      form.timezone_id = info?.timezone?.id
    },
    async getATEInfo(api, id, config) {
      try {
        const { data } = await api.info(id, null, config)
        return data
      } catch (e) {
        if (!isCancel(e)) {
          this.$notice.errors(e)
        }
        return Promise.reject(e)
      }
    },
  },
}
</script>

<style lang="scss">

.users-form {
  &__status {
    &-container {
      position: sticky;
      top: calc(#{$header-height} + 20px);
      min-width: 360px;
    }
  }
}
</style>
